import { get } from 'lodash-es'

class UserUtils {

  static isPrimaryMember(customerInfo) {
    return get(customerInfo, 'memberType') === 'PRIMARY'
  }

  static isHouseholdMember(customerInfo) {
    return get(customerInfo, 'memberType') === 'HOUSEHOLD'
  }

  static isMember(customerInfo) {
    return this.isPrimaryMember(customerInfo) || this.isHouseholdMember(customerInfo)
  }

  static isEmployee(customerInfo) {
    return get(customerInfo, 'employeeType') === 'ACTIVE'
  }

  static canPurchaseMembership(customerInfo) {
    return get(customerInfo, 'eligibleToPurchase') === true
  }
}

export default UserUtils
